export default {
  name: 'KazangModule',
  state: {
  },
  getters: {},
  mutations: {},
  actions: {
    async processPayment(context, payload) {
      const url = `${pettyCashApi}api/kazang/payment/incoming`;
      return await axios.post(url, payload)
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },
    async fetchBranches(context, userId) {
      const url = `${pettyCashApi}api/businesses/branches?userId=${userId}`;
      const headers = { "X-API-KEY": context.getters.getterApikey};

      return await axios.get(url, { headers })
        .then(({data}) => {
          if(!data) {
            data = context.getters.getBranch;
          }
          return data;
        }).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },
    async fetchAllBranches(context) {
      const url = `${pettyCashApi}api/businesses/branches`;
      const headers = { "X-API-KEY": context.getters.getterApikey};

      return await axios.get(url, { headers })
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },

    async checkInvoiceNumber(context, payload) {
      const subscriptionManagerUrl = window.subscriptionManager || 'https://lytningtomcat.chrilantech.com/SubscriptionManager/';
      const url = `${subscriptionManagerUrl}api/addons/invoice/${payload}/contains/2`;

      return await axios.get(url, payload)
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },

    async getStoreByID(context, payload) {
      const url = `${pettyCashApi}api/stores/${payload}`;

      return await axios.get(url)
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },

    async searchDebtors(context, { storeDatabase, searchQuery }) {
      const url = `https://lytningtomcat.chrilantech.com/Franchise_OnlineServer/debtor/${storeDatabase}/search`;
      const payload = {
        "Name": searchQuery,
        "tpin": "",
        "contact": "",
        "isCash": false,
        "Limit": 20, // Increased limit for better search results
        "orderBy": "Name asc"
      };
      // Note: This is a POST request as per the user's instructions
      return await axios.post(url, payload)
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },

    async registerKazangUser(context, payload) {
      const url = `${pettyCashApi}api/kazangSignUp/signup`;

      return await axios.post(url, payload, )
        .then(({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        })
    },

    async step1(context, payload) {
      console.log('[KazangModule] step1 called with payload:', payload);
      const url = `${pettyCashApi}api/kazang/payment/external/step1`;
      const headers = { "X-API-KEY": context.getters.getterApikey };
      console.log('[KazangModule] Business API key for headers:', context.getters.getterApikey);

      // Extract Kazang API_KEY from payload before sending to step1 endpoint
      const kazangApiKey = payload.API_KEY;
      console.log('[KazangModule] Extracted kazangApiKey from payload:', kazangApiKey);
      const { API_KEY, ...payloadData } = payload;

      return await axios.post(url, payloadData, { headers })
        .then(async ({data}) => {
          
          // Create a new, clean payload for the Kazang gateway
          const kazangPayload = { ...payload }; // copy original payload
          kazangPayload.Client_Refrence = data.reference_id;
          kazangPayload.API_KEY = kazangApiKey; // Ensure the correct key is used

          const info = await context.dispatch("createTransaction", kazangPayload);
          data.url = info.url;
          data.ID = info.ID;
          return data;
        }).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        });
    },
    async createTransaction(context, payload) {
      const url = `${KazangPaymentGatewayV2}GateWay/CreateTransaction`;
      const resolvedStoreId = payload.store_id || payload.storeId || context.getters.getStoreId;
      payload.store_id = resolvedStoreId;
      return await axios.post(url, payload)
        .then( async ({data}) => data).catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        });
    },

    /**
     * Kazang deposit Phase 1: issue a deposit OTP. Returns the new
     * transactionId plus a masked phone hint. Errors propagate via
     * errorHandler.tomcatError; the caller should catch and re-throw so the
     * form can react to 401 / 429 distinctly.
     */
    async depositPhase1(context, payload) {
      const url = `${pettyCashApi}api/kazang/deposit/phase1`;
      const headers = { "X-API-KEY": context.getters.getterApikey };
      return await axios.post(url, payload, { headers })
        .then(({ data }) => data)
        .catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        });
    },

    /** Kazang deposit Phase 2: submit the OTP. On success, a Transaction row
     *  of type DEPOSIT is persisted server-side. */
    async depositPhase2(context, payload) {
      const url = `${pettyCashApi}api/kazang/deposit/phase2`;
      const headers = { "X-API-KEY": context.getters.getterApikey, "Content-Type": "application/json" };
      return await axios.post(url, payload, { headers })
        .then(({ data }) => data)
        .catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        });
    },
    /**
     * Kazang deposit with an active session (no OTP). Same endpoint as
     * the per-deposit phase2, but the body carries sessionId instead of
     * transactionId+otp. Used by the session flow's kazangSession module.
     *
     * @param {Object} payload - { sessionId, branchId, localid, provider, reason, account, amount }
     * @returns {Object} the response body from the backend (LocalID envelope)
     */
    async depositWithSession(context, payload) {
      const url = `${pettyCashApi}api/kazang/deposit/phase2`;
      const headers = { "X-API-KEY": context.getters.getterApikey, "Content-Type": "application/json" };
      return await axios.post(url, payload, { headers })
        .then(({ data }) => data)
        .catch((err) => {
          // Surface the error to the caller (kazangSession/depositWith).
          // Do NOT call errorHandler.tomcatError here — the caller decides UX.
          throw err;
        });
    },


    /** Resume a Phase 1 session after a page reload. 404 if the session is gone. */
    async getDepositSession(context, transactionId) {
      const url = `${pettyCashApi}api/kazang/deposit/phase1/${transactionId}`;
      const headers = { "X-API-KEY": context.getters.getterApikey };
      return await axios.get(url, { headers })
        .then(({ data }) => data)
        .catch((err) => {
          errorHandler.tomcatError(err);
          throw err;
        });
    },
  }
}
